import { faKey } from '@fortawesome/pro-regular-svg-icons'

export const getUserViewRoutes = ({ history, showSessionLogs, isMFAEnabled }) => {
  const views = [
    {
      itemType: 'section',
      label: 'directory'
    },
    {
      icon: faKey,
      label: 'Service Accounts',
      variant: 'primary',
      onClick() {
        history.push('/user/service-accounts/aws')
      },
      _meta: {
        itemActiveRoutes: '/user/service-accounts/aws'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>devices</span>,
      label: 'devices',
      variant: 'primary',
      onClick() {
        history.push('/user/devices')
      },
      _meta: {
        itemActiveRoutes: '/user/devices'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>passkey</span>,
      label: 'My Vault',
      variant: 'primary',
      onClick() {
        history.push('/user/my-vault')
      },
      _meta: {
        itemActiveRoutes: '/user/my-vault'
      }
    },
    {
      itemType: 'section',
      label: 'cloud'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>stacks</span>,
      label: 'Targets',
      variant: 'primary',
      onClick() {
        history.push('/user/targets')
      },
      _meta: {
        itemActiveRoutes: '/user/targets'
      }
    },
    {
      CustomIcon: (
        <span className='material-symbols-outlined text-[18px]'>domain_verification</span>
      ),
      label: 'Resources',
      variant: 'primary',
      onClick() {
        history.push('/user/resources')
      },
      _meta: {
        itemActiveRoutes: '/user/resources'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>engineering</span>,
      label: 'IAM Roles',
      variant: 'primary',
      onClick() {
        history.push('/user/iam-roles/aws')
      },
      _meta: {
        itemActiveRoutes: '/user/iam-roles'
      }
    },
    {
      itemType: 'section',
      label: 'Permission Management'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>category</span>,
      label: 'SaaS Apps',
      variant: 'primary',
      onClick() {
        history.push('/user/saas-apps')
      },
      _meta: {
        itemActiveRoutes: '/user/saas-apps'
      }
    },
    {
      itemType: 'section',
      label: 'AI Security'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>cognition</span>,
      label: 'Agentic Apps',
      variant: 'primary',
      onClick() {
        history.push('/user/agentic-apps')
      },
      _meta: {
        itemActiveRoutes: '/user/agentic-apps'
      }
    },
   {
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>cloud_done</span>,
    label: 'Workload Agents',
    variant: 'primary',
    onClick() {
      history.push('/user/workload-agents')
    },
    _meta: {
      itemActiveRoutes: '/user/workload-agents',
      showShadowAI: true
    }
  },
    {
      itemType: 'section',
      label: 'Secrets'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>encrypted</span>,
      label: 'Hubs',
      variant: 'primary',
      onClick() {
        history.push('/user/secrets/hub')
      },
      _meta: {
        itemActiveRoutes: '/user/secrets'
      }
    },
    {
      itemType: 'section',
      label: 'Access Management'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>psychology_alt</span>,
      label: 'Access Requests',
      variant: 'primary',
      onClick() {
        history.push('/user/access-requests')
      },
      _meta: {
        itemActiveRoutes: '/user/access-requests'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>front_hand</span>,
      label: 'HITL Requests',
      variant: 'primary',
      onClick() {
        history.push('/user/agent-approvals')
      },
      _meta: {
        itemActiveRoutes: '/user/agent-approvals'
      }
    },
    {
      CustomIcon: (
        <span className='material-symbols-outlined text-[18px]'>assignment_turned_in</span>
      ),
      label: 'Access Policies',
      variant: 'primary',
      onClick() {
        history.push('/user/policys')
      },
      _meta: {
        itemActiveRoutes: '/user/policys'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>deployed_code</span>,
      label: 'Bundles',
      variant: 'primary',
      onClick() {
        history.push('/user/bundles')
      },
      _meta: {
        itemActiveRoutes: '/user/bundles'
      }
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>sell</span>,
      label: 'Tag Policies',
      variant: 'primary',
      onClick() {
        history.push('/user/tags')
      },
      _meta: {
        itemActiveRoutes: '/user/tags'
      }
    },
    {
      itemType: 'section',
      label: 'Activity'
    },
    {
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>vital_signs</span>,
      label: 'activity logs',
      variant: 'primary',
      onClick() {
        history.push('/user/activity-logs')
      },
      _meta: {
        itemActiveRoutes: '/user/activity-logs'
      }
    }
  ]

  if (showSessionLogs) {
    views.push({
      CustomIcon: <span className='material-symbols-outlined text-[18px]'>show_chart</span>,
      label: 'Session Logs',
      variant: 'primary',
      onClick() {
        history.push('/user/session-logs')
      },
      _meta: {
        itemActiveRoutes: '/user/session-logs'
      }
    })
  }

  views.push({
    itemType: 'section',
    label: 'Connections'
  })
  views.push({
    CustomIcon: <span className='material-symbols-outlined text-[18px]'>lan</span>,
    label: 'RDP User Management',
    variant: 'primary',
    onClick() {
      history.push('/user/addomaincontrollers')
    },
    _meta: {
      itemActiveRoutes: '/user/addomaincontrollers'
    }
  })

  return views
}
